<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@font-face {
  font-family: "Avenir";
  src: url("../public/assets/fonts/Avenir-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Avenir";
  src: url("../public/assets/fonts/Avenir-Black.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Avenir";
  src: url("../public/assets/fonts/Avenir-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Avenir";
  src: url("../public/assets/fonts/Avenir-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
*,
*::before,
*::after {
  font-family: "Avenir", sans-serif;
}

/* INICIO ESTILOS BASE PARA DERMAPP (CONTENEDORES Y FUENTES GENERALES) */
.main-style {
  background: #38b6ff;
  min-height: 100vh;
  width: 100vw;
  position: relative; /* o cualquier otro positioning que defina el contenedor */
  font-family: "Avenir", sans-serif;
}
.header {
  background: #36b5ff;
  margin-top: -5px;
}

.subtext {
  text-align: left;
  font-weight: 300;
  color: #66717e;
  font-size: 12px;
  font-style: normal;
  display: inline;
  background: #e7ebee;
  padding: 2px 6px;
  border-radius: 6px;
}

.subtext-help {
  text-align: left;
  font-weight: 500;
  font-size: 0.8rem;
  font-style: normal;
  display: inline;
  border-radius: 6px;
}

.subtext-image {
  text-align: start;
  font-weight: 500;
  color: #367cf8;
  font-size: 0.83rem;
  font-style: normal;
  display: inline;
  background: #dde6fe;
  border-radius: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.subtitle-data {
  font-size: 0.9rem;
  text-align: start;
  color: #9d9d9d;
  font-weight: 600;
}

.btn-blue {
  background: #367cf8;
  border: 2px solid #367cf8;
  color: white;
  border-radius: 12px;
  font-family: "Comfortaa", sans-serif;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  width: 50%;
}

/* 1) CELULARES: hasta 767px */
@media (max-width: 767px) {
  .main-container {
    display: flex;
    align-items: center; /* centra vertical */
    justify-content: center; /* centra horizontal */
    height: fit-content; /* ocupa toda la altura de la ventana */
  }

  .form-container {
    background: white;
    padding: 20px;
    height: 100%;
    margin-left: 7.5%;
    margin-right: 7.5%;
    width: 85vw; /* 85vw celular, 80vw ipad, 40 desktop. Centrarlo ipad 50% boton%*/
    border-radius: 12px;
    margin-bottom: 5vh;
  }

  .thumbnail-assets {
    width: 25vw;
    height: 25vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }

  .thumbnail {
    width: 25vw;
    height: 25vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }

  .btn-blue {
    background: #367cf8;
    border: 2px solid #367cf8;
    color: white;
    border-radius: 12px;
    font-family: "Comfortaa", sans-serif;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 10px;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    width: 100%;
  }

  .picture-tips {
    font-size: 1rem !important;
    text-align: justify;
  }

  .picture-tips p {
    padding-top: 5px;
    font-size: 0.9rem !important;
    text-align: start;
  }

  .subtitle-data {
    font-size: 0.75rem;
    text-align: start;
    color: #9d9d9d;
    font-weight: 600;
  }

  .subtext-image {
    text-align: start;
    font-weight: 800;
    color: #367cf8;
    font-size: 0.75rem;
    font-style: normal;
    display: inline;
    background: #dde6fe;
    border-radius: 6px;
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

/* 2) TABLETS (iPad y similares): de 768px a 1024px */
@media (min-width: 768px) and (max-width: 1024px) {
  .main-container {
    display: flex;
    align-items: center; /* centra vertical */
    justify-content: center; /* centra horizontal */
    vertical-align: middle;
    height: fit-content; /* ocupa toda la altura de la ventana */
  }

  .form-container {
    background: white;
    padding: 20px;
    height: 100%;
    width: 80vw; /* 85vw celular, 80vw ipad, 40 desktop. Centrarlo ipad 50% boton%*/
    border-radius: 10px;
    margin-bottom: 5vh;
  }

  .thumbnail-assets {
    width: 18vw;
    height: 18vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
  .thumbnail {
    width: 8vw;
    height: 8vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }

  .picture-tips {
    font-size: 1.25rem !important;
  }

  .picture-tips p {
    font-size: 1.2rem !important;
  }
}

/* 3) DESKTOP ( >1024px ) */
@media (min-width: 1025px) and (max-width: 1199px) {
  .main-container {
    display: flex;
    align-items: center; /* centra vertical */
    justify-content: center; /* centra horizontal */
    height: fit-content; /* ocupa toda la altura de la ventana */
  }

  .form-container {
    background: white;
    padding: 20px;
    height: 100%;
    margin-left: 30%;
    margin-right: 30%;
    width: 40vw; /* 85vw celular, 80vw ipad, 40 desktop. Centrarlo ipad 50% boton%*/
    border-radius: 10px;
    margin-bottom: 5vh;
  }

  .thumbnail-assets {
    width: 18vw;
    height: 18vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
}

/* 3) Monitores grandes (22″ en adelante, ~1920px+) */
@media (min-width: 1200px) {
  .main-container {
    display: flex;
    align-items: center; /* centra vertical */
    justify-content: center; /* centra horizontal */
    height: fit-content; /* ocupa toda la altura de la ventana */
  }

  .form-container {
    background: white;
    padding: 20px;
    height: 100%;
    margin-left: 25%;
    margin-right: 25%;
    width: 50vw; /* 85vw celular, 80vw ipad, 40 desktop. Centrarlo ipad 50% boton%*/
    border-radius: 10px;
    margin-bottom: 5vh;
  }

  .thumbnail-assets {
    width: 8vw;
    height: 8vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
  .thumbnail {
    width: 8vw;
    height: 8vw;
    object-fit: cover;
    border-radius: 12%;
    margin: 1px;
    border: 1px solid #ddd;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }

  .picture-tips {
    font-size: 1.25rem !important;
  }

  .picture-tips p {
    font-size: 1.2rem !important;
  }
}

/* Estilos para los puntos del banner */
.dots {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 5px;
}
.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: background 0.2s;
}
.dot.active {
  background: #37b6ff;
  width: 15px;
  border-radius: 15px;
}

/* FIN ESTILOS BASE PARA DERMAPP */

/* 1) REMOVE all built-in art: hide pseudo-elements, SVGs, borders & shadows */
.swal2-icon.swal2-success,
.swal2-icon.swal2-error,
.swal2-icon.swal2-warning {
  border: none !important;
  background: none !important;
  box-shadow: none !important;
  color: transparent !important; /* hides “!” text in warning */
}

/* hide every little span/svg they use */
.swal2-icon.swal2-success .swal2-success-ring,
.swal2-icon.swal2-success .swal2-success-circular-line-left,
.swal2-icon.swal2-success .swal2-success-circular-line-right,
.swal2-icon.swal2-success .swal2-success-line-tip,
.swal2-icon.swal2-success .swal2-success-line-long,
.swal2-icon.swal2-error .swal2-x-mark,
.swal2-icon.swal2-warning .swal2-icon-content,
.swal2-icon.swal2-success .swal2-success-fix,
.swal2-icon.swal2-question .swal2-icon-content,
.swal2-icon.swal2-question .swal2-question-ring,
.swal2-icon.swal2-warning svg {
  display: none !important;
}

.swal2-icon.swal2-question {
  border: none !important;
  outline: none !important;
}

/* 2) NOW inject your own images! */
.swal2-icon.swal2-success {
  width: 80px !important;
  height: 80px !important;
  background: url("@/assets/swal-check.png") center/contain no-repeat !important;
}

.swal2-icon.swal2-error {
  width: 80px !important;
  height: 80px !important;
  background: url("@/assets/swal-error.png") center/contain no-repeat !important;
}

.swal2-icon.swal2-warning {
  width: 80px !important;
  height: 80px !important;
  background: url("@/assets/swal-warning.png") center/contain no-repeat !important;
}

.swal2-icon.swal2-question {
  width: 80px !important;
  height: 80px !important;
  background: url("@/assets/swal-question.png") center/contain no-repeat !important;
}
</style>
